import React, { createContext, useState, useEffect } from 'react';
import PubSub from 'pubsub-js'
import { Col, Container, Row } from 'react-bootstrap';
import DataPoint from '../metrics/DataPoint';
import CasesRecieved from '../../controls/charts/CasesRecieved';
import CompletedCases from '../../controls/charts/CompletedCases';
import TatAverages from '../../controls/charts/TatAverages';
import CustomerCodingEventService from '../../services/CustomerCodingEventService';
import { useImmer } from 'use-immer';
import moment from 'moment';

const CustomerAdmin = (props) => {
    const [viewModel, setViewModel] = useImmer({});
    const [startOfWeek, setStartOfWeek] = useImmer('');
    const [endOfWeek, setEndOfWeek] = useImmer('');
    const [weekText, setWeekText] = useImmer('');

    useEffect(() => {
        getMetrics();
        setUpDates();
    }, [])

    const setUpDates = () => {
        let currDate = new Date();
        let sow = moment(currDate).startOf('week').add(1, "days").format('M/D');
        let eow = moment(currDate).endOf('week').add(1, "days").format('M/D');
        let week = `Week ${sow}-${eow}`;
        setStartOfWeek(sow);
        setEndOfWeek(eow);
        setWeekText(week);
    }

    const getMetrics = async () => {
        var service = new CustomerCodingEventService();

        var callResult = await service.getMetrics();
        if (callResult.result) {
            setViewModel(callResult.model);
        }
    }

    return (
        <Container>
            {/*{JSON.stringify(viewModel, null, 2)}*/}
            <Row>
                <Col className="data-point-parent">
                    <DataPoint
                        title="Received"
                        dataPoint={viewModel.received}
                        desc={weekText} />
                    {/*onClick={() => window.open("http://www.yahoo.com", '_blank').focus()}*/}
                </Col>
                <Col className="data-point-parent">
                    <DataPoint
                        title="Completed"
                        dataPoint={viewModel.completed}
                        desc={weekText} />
                </Col>
                <Col className="data-point-parent">
                    <DataPoint
                        title="Cancelled"
                        dataPoint={viewModel.cancelled ? viewModel.cancelled : "0"}
                        desc={weekText} />
                </Col>
                <Col className="data-point-parent">
                    <DataPoint
                        title="In Progress"
                        dataPoint={viewModel.inProgress}
                        desc="Total" />
                </Col>
                <Col className="data-point-parent">
                    <DataPoint
                        title="Not Started"
                        dataPoint={viewModel.notStarted}
                        desc="Total" />
                </Col>
                <Col className="data-point-parent">
                    <DataPoint
                        title="On Hold"
                        dataPoint={viewModel.onHold}
                        desc="Total" />
                </Col>
            </Row>
            <Row>
                <Col lg={6} className="chart-parent">
                    <CompletedCases data={viewModel.weeklyStats}/>
                </Col>
                <Col lg={6} className="chart-parent">
                    <TatAverages chartData={viewModel.tatMetrics} />
                </Col>
            </Row>
        </Container>

    )
}

export default CustomerAdmin;